import { TranslateService } from '@ngx-translate/core';

import { Component, OnInit } from '@angular/core';
import { AppSettingService } from 'src/app/services/app-setting.service';

@Component({
  selector: 'app-multi-lingual',
  templateUrl: './multi-lingual.component.html',
  styleUrls: ['./multi-lingual.component.css'],
  //providers:[AppSettingService]
})
export class MultiLingualComponent implements OnInit {

  supportedLangs: any = []

  constructor(public appSettingService: AppSettingService, public translate: TranslateService) {
    // this.supportedLangs = this.translate.getLangs();
    translate.addLangs(["en", "es"]);
    this.supportedLangs = this.appSettingService.supportedLangs
    //  this.selectLang('en')
    this.appSettingService.currentLanguage=this.appSettingService.currentLanguage||'en'
    translate.use(this.appSettingService.currentLanguage);
    console.log("lang1")
  }

  setLanguage(lang: any) {
    //this.translate.use(lang);
   // this.translate.setDefaultLang(lang);
    this.selectLang(lang);
  }
  ngOnInit() {

  }

  selectLang(lang: string) {

    this.appSettingService.currentLanguage = lang;

    this.translate.use(lang);
    if (lang == 'es')
      document.getElementById("body").classList.add("lang-sp")
    else {
      document.getElementById("body").classList.remove("lang-sp")
    }


  }
  isCurrentLang(lang) {  
   
    return    lang === this.appSettingService.currentLanguage;
 }


}
